module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_03_sp-cec1da9e5c27d8d5bd5edea5cf5ec447.png";